const getters = {
  getOrganizations: (state) => state.organizations,
  getOrganization: (state) => state.organization,
  getOrganizationsProductCategories: (state) => state.product_categories,
  getOrganizationsTemplateRole: (state) => state.template_role,
};

export default getters;
